module.exports = __webpack_public_path__ + "img/142.f58d52a6.jpg";